import { Stack } from "@mui/material";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

export const HubHookFormDragTable = ({
  id = "Table",
  rootRef,
  fields = [],
  stackProps = {},
  baseProps = {},
  validate = () => true,
  move = () => {},
  getIsDisabled = () => {},
  RenderRow,
  Header,
  children,
}) => {
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const start = result.source.index;
    const end = result.destination.index;

    const valid = validate(start, end);
    if (!valid) return;
    move(start, end);
  };

  return (
    <Stack gap="8px">
      <Stack id={id} border="1px solid" borderColor="hubColors.greyLight">
        {Header && <Header />}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="dip-dips">
            {(provided) => (
              <Stack
                {...provided.droppableProps}
                ref={(node) => {
                  provided.innerRef(node);
                  if (rootRef) rootRef.current = node;
                }}
                {...stackProps}
              >
                {fields?.map((field, idx) => {
                  const key = field.id;
                  const props = { field, idx, ...baseProps };
                  const disabled = getIsDisabled(field, idx);

                  return (
                    <Draggable
                      key={key}
                      draggableId={key}
                      index={idx}
                      isDragDisabled={disabled}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          {RenderRow && <RenderRow {...props} />}
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </Stack>
            )}
          </Droppable>
        </DragDropContext>
      </Stack>
      {children}
    </Stack>
  );
};

export default HubHookFormDragTable;
